import React from 'react';
import * as Styled from './ResultImageList.styled';
import { resultItem } from '../../../proptypes/Actions';
import TextLabel, { TextLabelTypes } from '../../atoms/TextLabel/TextLabel';
import ResultText from '../../atoms/ResultText/ResultText';
import ImagePreview from '../ImagePreview/ImagePreview';

const ResultImageList = (props) => {
  const imageChildActions = props.resultItem.childItems.filter(
    (childItem) => childItem.inputType === 'image'
  );
  return (
    <Styled.Wrapper>
      {props.resultItem.text && (
        <ResultText>{props.resultItem.text}</ResultText>
      )}
      {imageChildActions.map((child, index) => {
        return (
          <React.Fragment key={child.id}>
            <TextLabel type={TextLabelTypes.GREY_BOLD}>{child.title}</TextLabel>
            {child.image?.url && <ImagePreview file={child.image} />}
          </React.Fragment>
        );
      })}
    </Styled.Wrapper>
  );
};

ResultImageList.propTypes = { resultItem: resultItem };

export default ResultImageList;
